import { render } from "./Tipsters.vue?vue&type=template&id=3e10bb84&scoped=true"
import script from "./Tipsters.vue?vue&type=script&lang=js"
export * from "./Tipsters.vue?vue&type=script&lang=js"

import "./Tipsters.vue?vue&type=style&index=0&id=3e10bb84&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e10bb84"]])

export default __exports__